"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AddonsSettings_1 = __importDefault(require("./AddonsSettings"));
exports.default = AddonsSettings_1.default;
